
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingAcrissList } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormAcrissList = () => {

    const { t } = useTranslation('booking');

    const acrissListQuery = useQuery({
        queryKey: [ReactQueryKey.BookingAcrissList,{tenants:[],dealers:[]}],
        queryFn: () => getBookingAcrissList({tenants:[],dealers:[]}),
        enabled: false
    });

    const handleOnOpen = () => {
        if(acrissListQuery.data == undefined) 
            acrissListQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="acrissList"
            label={t('label.acrissList')}
            options={acrissListQuery.data || []}
            loading={acrissListQuery.isLoading}
            multiple
            onOpen={handleOnOpen}
        />
    );
};

export default FormAcrissList;